import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useHistoryStore,
  selectHistoryEntries,
  selectHistoryFilters
} from '../state/historyStore';

export function HistoryFilters() {
  const { t } = useTranslation();
  const filters = useHistoryStore(selectHistoryFilters);
  const setFilters = useHistoryStore((state) => state.setFilters);
  const entries = useHistoryStore(selectHistoryEntries);

  const styleOptions = useMemo(() => {
    const unique = new Map<string, string>();
    entries.forEach((entry) => {
      unique.set(entry.style.id, entry.style.name);
    });
    return Array.from(unique.entries());
  }, [entries]);

  const dateOptions = useMemo(() => {
    const formatter = new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: 'short',
      day: '2-digit'
    });
    const unique = new Map<string, string>();
    entries.forEach((entry) => {
      const dateKey = entry.createdAt.slice(0, 10);
      unique.set(dateKey, formatter.format(new Date(entry.createdAt)));
    });
    return Array.from(unique.entries());
  }, [entries]);

  return (
    <div className="flex flex-wrap gap-3 text-xs text-ai-text-secondary">
      <label className="flex items-center gap-2">
        <span>{t('history.filters.style')}</span>
        <select
          className="rounded-full border border-ai-surface-glow/30 bg-ai-surface-elevated/70 px-3 py-1 text-ai-text-primary focus:outline-none focus-visible:ring focus-visible:ring-ai-focus"
          value={filters.styleId}
          onChange={(event) => setFilters({ styleId: event.target.value as typeof filters.styleId })}
        >
          <option value="all">{t('history.filters.all')}</option>
          {styleOptions.map(([id, name]) => (
            <option key={id} value={id}>
              {name}
            </option>
          ))}
        </select>
      </label>
      <label className="flex items-center gap-2">
        <span>{t('history.filters.date')}</span>
        <select
          className="rounded-full border border-ai-surface-glow/30 bg-ai-surface-elevated/70 px-3 py-1 text-ai-text-primary focus:outline-none focus-visible:ring focus-visible:ring-ai-focus"
          value={filters.date}
          onChange={(event) => setFilters({ date: event.target.value as typeof filters.date })}
        >
          <option value="all">{t('history.filters.all')}</option>
          {dateOptions.map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
